<template>
  <v-data-table
    class="elevation-2"
    :headers="[
      { text: 'Created At', value: 'createdAt' },
      { text: 'Lenders Matched With', value: 'matches.length' },
      { text: '', value: 'actions', sortable: false },
    ]"
    :items="deals"
    sort-by="createdAt" sort-desc must-sort
    show-expand
  >
    <template #top>
      <v-toolbar flat color="white">
        <v-toolbar-title>User Deals</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
      </v-toolbar>
    </template>

    <template #item.createdAt="{ value }">
      {{ value | date }}
    </template>

    <template #item.matches.length="{ value }">
      {{ value || 'None' }}
    </template>

    <template #item.actions="{ item }">
      <dialog-delete-deal :dealId="item.id" @deleted="removeDeal(item)" />
    </template>

    <template #expanded-item="{ headers, item }">
      <td class="pa-2" :colspan="headers.length">
        <condensed-user-deal-details :deal="item"></condensed-user-deal-details>
      </td>
    </template>

    <template #no-data>
      This user has no deals
    </template>
  </v-data-table>
</template>

<script>
import CondensedUserDealDetails from './CondensedUserDealDetails'
import DialogDeleteDeal from './DialogDeleteDeal'

export default {
  name: 'UserDealsTable',
  components: {
    CondensedUserDealDetails,
    DialogDeleteDeal,
  },
  props: {
    deals: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    removeDeal (deal) {
      const index = this.deals.findIndex(({ id }) => id === deal.id)
      if (index > -1) this.deals.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
